import {Component} from "@angular/core";
import {AuthorizationService} from "./AuthorizationService";
import {Location as LocationService} from "@angular/common";
import {Router} from "@angular/router";

@Component({
    providers: [AuthorizationService, LocationService],
    template: "RequestSSO"
})

export class RequestSSOLoginComponent {
    constructor(
        private authorizationService: AuthorizationService,
        private locationService: LocationService,
        private router: Router
    ) {
        authorizationService.trySilentLogin()
            .then(() => router.navigate([""]), () => authorizationService.requestSSOLogin());
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Authorization/RequestSSOLoginComponent.ts